// extracted by mini-css-extract-plugin
export var banner = "ReconVndSetup-module--banner--a3fcd";
export var data = "ReconVndSetup-module--data--3cc3a";